import { Children, cloneElement, Component, isValidElement } from 'react';
import { List } from '../List';
import { InputValue } from '../types';

export interface MenuListProps {
    onItemClick?: (e: React.MouseEvent, value: InputValue) => void;
}

interface ChildProps {
    onAfterClick?: MenuListProps['onItemClick'];
    tabIndex?: number;
}

export class MenuInnerList extends Component<MenuListProps> {
    render() {
        const { onItemClick, children, ...other } = this.props;

        const items = Children.map(children, (c) => {
            if (!isValidElement<ChildProps>(c)) {
                return c;
            }

            return cloneElement(c, {
                ...(!!onItemClick && { onAfterClick: onItemClick }),
                tabIndex: -1,
            });
        });

        return <List {...other}>{items}</List>;
    }
}

export default MenuInnerList;
